import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

import FilterUserContent from '../../../entities/filter/user-content';
import { SimpleObject } from '../../../entities/simple-object';
import { fromJsDate } from '../../../services/formatter/date';
import { strings } from '../../../localization/strings';
import { createDateKeyDownHandler } from '../../../utils/date-input-handler';

export default function UserContentFilter({
  onUpdate,
  filterState,
  onExport,
}: {
  onUpdate: (filters: FilterUserContent) => void;
  // initialState: FilterUserContent;
  filterState: FilterUserContent;
  onExport: () => void;
}) {
  const [dateValue, setDateValue] = useState<SimpleObject<Date | null>>({
    starts_at: filterState.starts_at || null,
    ends_at: filterState.ends_at || null,
  });

  const onChangeDate = (startFieldName: string, endFieldName: string, date: [Date | null, Date | null]) => {
    setDateValue({ ...dateValue, [startFieldName]: date[0], [endFieldName]: date[1] });

    if (date[0] && date[1]) {
      onUpdate({ ...filterState, [startFieldName]: fromJsDate(date[0]), [endFieldName]: fromJsDate(date[1]) });
    }

    if (!date[0] && !date[1]) {
      onUpdate({ ...filterState, [startFieldName]: null, [endFieldName]: null });
    }
  };

  return (
    <div className="bg-white py-8">
      <div className="grid max-w-7xl grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
        <div className="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-6">
          <fieldset>
            <legend className="block font-medium">{strings.common.filter.dateRange}</legend>
            <div className="sm:mt-4">
              <DatePicker
                monthsShown={2}
                showYearDropdown
                dateFormat="yyyy-MM-dd"
                isClearable
                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                selectsRange
                startDate={dateValue.starts_at}
                selected={dateValue.starts_at}
                endDate={dateValue.ends_at}
                onChange={(date) => onChangeDate('starts_at', 'ends_at', date)}
                onKeyDown={createDateKeyDownHandler(
                  'starts_at',
                  'ends_at',
                  dateValue,
                  filterState,
                  setDateValue,
                  onUpdate,
                )}
              />
            </div>
          </fieldset>
          <button
            type="button"
            className="relative inline-flex items-center justify-center gap-x-1.5 rounded-md mt-9 px-1 py-1 text-sm font-semibold text-white bg-[#3574d1] hover:bg-[#2c5fb0] focus:ring-2 focus:ring-offset-2 focus:ring-[#3574d1] max-h-[40px] max-w-[100px]"
            onClick={onExport}
          >
            EXPORT
          </button>
        </div>
      </div>
    </div>
  );
}
